module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "行业管理",
      "name": "0"
    }
  }, [_c('tag', {
    ref: "industryInput",
    attrs: {
      "active-name": _vm.activeName,
      "list": _vm.industryList
    },
    on: {
      "addIndustry": _vm.addIndustry,
      "delIndustry": _vm.delIndustry
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "内容类别管理",
      "name": "1"
    }
  }, [_c('tag', {
    ref: "domainInput",
    attrs: {
      "active-name": _vm.activeName,
      "list": _vm.domainList
    },
    on: {
      "addDomain": _vm.addDomain,
      "delDomain": _vm.delDomain
    }
  })], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0b6615c0!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/industry/industry.vue
// module id = 443
// module chunks = 11